module.exports = __webpack_public_path__ + "static/media/omocestus_viridulus_003_APA.89cfd0cb.png";